
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-policy",
      function () {
        return require("private-next-pages/terms-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-policy"])
      });
    }
  